var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.90998 8.57751c-.15568.15741-.24299.36986-.24299.59125 0 .22138.08731.43384.24299.59125l2.44916 2.47079c.18167.1792.41667.2684.64916.2684.2325 0 .4633-.0892.6408-.2684l2.4417-2.46246c.1555-.15752.2427-.36993.2427-.59125s-.0872-.43373-.2427-.59125c-.0765-.07765-.1677-.13932-.2683-.18141s-.2085-.06376-.3175-.06376-.217.02167-.3176.06376c-.1005.04209-.1917.10376-.2683.18141l-1.915 1.93086-1.92246-1.93919c-.07669-.07735-.16795-.13875-.2685-.18065s-.2084-.06347-.31733-.06347-.21678.02157-.31733.06347-.19181.1033-.2685.18065z",
    fill: "#494949",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDropdown);
export default __webpack_public_path__ + "static/media/ico_dropdown.a31632af6152c203c091c0e58b0bb801.svg";
export { ForwardRef as ReactComponent };